"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxImageSizeValidator = exports.isAllowedTypeValidator = void 0;
var _lodash = require("lodash");
var isAllowedTypeValidator = function isAllowedTypeValidator() {
  var allowedTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var msg = arguments.length > 1 ? arguments[1] : undefined;
  return function (file) {
    var fileTypeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isValid = allowedTypes.length && allowedTypes.some(function (t) {
      return t === fileTypeData.mime;
    });
    return {
      isValid: isValid,
      message: (0, _lodash.isFunction)(msg) ? msg(file, fileTypeData.ext) : msg
    };
  };
};
exports.isAllowedTypeValidator = isAllowedTypeValidator;
var maxImageSizeValidator = function maxImageSizeValidator(limit, msg) {
  return function (file) {
    var isValid = file.size / 1024 / 1024 < limit;
    return {
      isValid: isValid,
      message: msg
    };
  };
};
exports.maxImageSizeValidator = maxImageSizeValidator;